import * as Rpc from "./rpc";
import type { CreateAssignmentResult } from "./rpc";

export type Assignment = Omit<
  Rpc.AssignmentResourceSchema,
  "__type" | "__primitiveFields" | "auditPlan" | "auditPlanId"
>;
export type CreateAssignmentData = Extract<
  CreateAssignmentResult,
  { success: true }
>["data"];

export const getAssignmentById = async (id: string) => {
  const response = await Rpc.getAssignment({
    getBy: { id },
    fields: [
      "id",
      "name",
      "state",
      "type",
      "description",
      "startDate",
      "endDate",
      "completionPercentage",
      "insertedAt",
      "updatedAt",
    ],
  });

  if (response.success) {
    return response.data;
  } else {
    throw Error(`Error fetching Assignment id: ${id}`);
  }
};

export const createAssignment = async (
  input: Rpc.CreateAssignmentInput,
): Promise<CreateAssignmentData> => {
  const response = await Rpc.createAssignment({ input });

  if (response.success) {
    return response.data;
  } else {
    throw new Error("Error while creating a new assignment");
  }
};
